import { Box } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import WhatwedoBg from "../../assets/images/whatwedobanner.webp";

const WhatwedoBglanding = () => {
  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: "5rem",
        backgroundColor: "#ecebeb",
      }}
    >
      <Box sx={{}}>
        <LazyLoadImage
          src={WhatwedoBg}
          effect="blur"
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  );
};

export default WhatwedoBglanding;
